import { epoch, utc } from '../../util/datetime';
import type { ITicketInsurance } from './TicketInsurance.interface';

export default class TicketInsurance implements ITicketInsurance {
  insurerName: string;
  coverAmount: number;
  policyNumber: string;
  productType: string;
  premiumStartDate: number;
  premiumEndDate: number;
  premiumAmountInSuper: number;
  premiumAmountOutSuper: number;
  premiumFrequency: string;
  policyNotes: string;

  static build = (data: ITicketInsurance) => new TicketInsurance(data);
  static blank = () => new TicketInsurance();

  /**
   * Constructor
   * @param {ITicketInsurance} data
   */
  constructor(data?: ITicketInsurance) {
    this.insurerName = data?.insurerName || '';
    this.coverAmount = parseFloat(data?.coverAmount || 0);
    this.policyNumber = data?.policyNumber || '';
    this.productType = data?.productType || '';
    this.premiumStartDate = data?.premiumStartDate ? epoch(utc(data?.premiumStartDate)) : 0;
    this.premiumEndDate = data?.premiumEndDate ? epoch(utc(data?.premiumEndDate)) : 0;
    this.premiumAmountInSuper = parseFloat(data?.premiumAmountInSuper || 0);
    this.premiumAmountOutSuper = parseFloat(data?.premiumAmountOutSuper || 0);
    this.premiumFrequency = data?.premiumFrequency || '';
    this.policyNotes = data?.policyNotes || '';
  }
}
